// API Configuration
const getBackendUrl = () => {
  let envUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:3333";

  // If accessed via a network IP, replace 'localhost' with that IP
  if (typeof window !== "undefined" && envUrl.includes("localhost")) {
    envUrl = envUrl.replace("localhost", window.location.hostname);
  }

  // Ensure it ends with /admin and handle trailing slashes correctly
  const baseUrl = envUrl.replace(/\/+$/, "");
  return baseUrl.endsWith("/admin") ? baseUrl : `${baseUrl}/admin`;
};

export const API_CONFIG = {
  BACKEND_URL: getBackendUrl(),
};
